module.exports = __webpack_public_path__ + "media/application/images/2023/05_still-1250x703-920720eeeac46d678f5c5af785a346ae.png";